import { Button } from '@workspace/ui/components/button'
import { Checkbox } from '@workspace/ui/components/checkbox'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@workspace/ui/components/dialog'
import { useState } from 'react'
import { useAcceptTermsMutation } from '@/hooks/api'
import { CURRENT_TERMS_VERSION } from '../constants'
import { TermsContent } from './terms-content'

export function TermsAcceptanceDialog() {
  const [agreed, setAgreed] = useState(false)
  const { mutate: acceptTerms, isPending } = useAcceptTermsMutation()

  function handleAccept() {
    acceptTerms({ body: { version: CURRENT_TERMS_VERSION } })
  }

  return (
    <Dialog open>
      <DialogContent
        showCloseButton={false}
        className="sm:max-w-2xl max-h-[85vh] flex flex-col"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Terms and Conditions</DialogTitle>
          <DialogDescription>
            Please review and accept our terms and conditions to continue.
          </DialogDescription>
        </DialogHeader>
        <div className="overflow-y-auto flex-1 pr-2 terms-scrollbar rounded-lg bg-card p-4">
          <TermsContent />
        </div>
        <DialogFooter className="flex-col gap-4 sm:flex-col">
          <div className="flex w-fit items-center gap-2">
            <Checkbox
              id="terms-agreement"
              checked={agreed}
              onCheckedChange={(checked) => setAgreed(checked === true)}
              className="border-[#555] size-5"
            />
            <label htmlFor="terms-agreement" className="text-sm cursor-pointer">
              I have read and agree to the Terms and Conditions
            </label>
          </div>
          <Button
            onClick={handleAccept}
            disabled={!agreed || isPending}
            className="w-full sm:w-auto"
          >
            {isPending ? 'Accepting...' : 'Accept and Continue'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
